export default "__VITE_ASSET__3d700fbc__"